import { render, staticRenderFns } from "./bind_department_item.vue?vue&type=template&id=4fc776e2"
import script from "./bind_department_item.vue?vue&type=script&lang=js"
export * from "./bind_department_item.vue?vue&type=script&lang=js"
import style0 from "./bind_department_item.vue?vue&type=style&index=0&id=4fc776e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports